import { Avatar, Stack, SxProps, Typography } from '@mui/material';
import { ErrorWarningSign } from 'Images';

interface IControlledErrorMessage {
  image?: string;
  sx?: SxProps;
  imageSx?: SxProps;
  errorMsg: string;
  errorMsgSx?: SxProps;
}

export const ControlledErrorMessage = ({
  image,
  sx,
  imageSx,
  errorMsg,
  errorMsgSx,
}: IControlledErrorMessage) => {
  return (
    <Stack direction='row' gap='7px' sx={sx} alignItems='center'>
      <Avatar
        alt=''
        src={image || ErrorWarningSign}
        sx={{ width: '20px', height: '20px', ...imageSx }}
      />
      <Typography
        sx={{
          color: '#d90000',
          fontSize: '18px',
          fontWeight: 400,
          fontFamily: 'inherit',
          ...errorMsgSx,
        }}
      >
        {errorMsg}
      </Typography>
    </Stack>
  );
};
